@if(isOpenPopup){
<div class="fixed-center" class="{{localService.selectedLanguageCode}}">
    <ngb-toast [header]="localService.languageContent.billing.payment_mode" [autohide]="false" (hidden)="onAction(1)">
        <div class="banner" style="margin-bottom: 5px;">
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <app-label [Text]="localService.languageContent.billing.amount" />
                    <span class="en" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                    <span class="en">{{(billAmount ?? '') | number: '1.2-2'}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <div>
                        <app-label [Text]="localService.languageContent.billing.paid_amount" />
                        <span class="en" [innerHTML]="currencyIcon"></span>
                        <span class="en" *ngIf="!isPaidAmountEditable" [ngClass]="{
                            'danger': toBePaid && toBePaid > billAmount
                        }">&nbsp;{{toBePaid | number:
                            '1.2-2'}}</span>
                        <input *ngIf="isPaidAmountEditable" autocomplete="off" type="number" class="number" [ngClass]="{
                            'danger': toBePaid && toBePaid > billAmount
                        }" (keypress)="localService.isNumberOnly($event,numericConfig)"
                            id="{{elementIds.txt_to_be_paid}}" [(ngModel)]="toBePaid" style="max-width: 100px;"
                            placeholder="{{localService.languageContent.billing.paid_amount}}"
                            title="{{localService.languageContent.billing.paid_amount}}"
                            [ngClass]="toBePaid != null ? 'en' : ''" />
                    </div>
                    <div *ngIf="toBePaid == null" style="text-align: justify;line-height: normal;color: orangered;">
                        {{localService.languageContent.billing.empty_amount}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <app-label [Text]="localService.languageContent.billing.balance" />
                    <span class="en" [innerHTML]="currencyIcon + '&nbsp;'"></span>
                    <span class="en">{{((billAmount ?? 0) - (toBePaid ?? billAmount)) | number: '1.2-2'}}</span>
                </div>
            </div>
        </div>
        <div class="banner" style="max-height: calc(100vh - 500px);overflow: auto;">
            <div *ngFor="let item of paymentMethods; index as idx">
                <div *ngIf="!isPaid || (isPaid && selectedPaymentMode == item.key)">
                    <div class="styled_row" >
                        <button class="button_link link_btn" [disabled]="isPaid || item.isInActive" [ngStyle]="{'opacity': item.isInActive ? 0.5 : 1}"
                            id="{{elementIds.btn_paymeny_mode + '_'+(idx+1)}}" (click)="onAction(2,item.key)">
                            <i class="icon_adjust"
                                [ngClass]="item.isSelected ? 'material-icons' : 'material-icons-outline'">
                                {{item.isSelected ? ' check_circle' : 'circle'}}
                            </i>
                            <span>{{item.value}}</span>
                            <label class="en" style="float: right;margin-right: 16px;" *ngIf="totalPaidAmount > 0">
                                <span class="en" [innerHTML]="currencyIcon"></span>
                                {{totalPaidAmount.toFixed(2)}}
                            </label>
                        </button>
                    </div>
                    <div class="box" *ngIf="item.isSelected && item.key == PaymentType.MultiPayment.toString()">
                        <div *ngFor="let itemSub of paymentMethods; index as idxJ">
                            <div class="row styled_row"
                                *ngIf="(!isPaid || (isPaid && itemSub.s_value)) && ![PaymentType.ShowQrCode.toString(),PaymentType.MultiPayment.toString()].includes(itemSub.key)">
                                <div class="col-7">
                                    <span>{{itemSub.value}}</span>
                                </div>
                                <div class="col-5" style="text-align: right;">
                                    <span class="en" [innerHTML]="currencyIcon"></span>
                                    <span class="en" *ngIf="isPaid">&nbsp;{{(itemSub.s_value ?? '') | number:
                                        '1.2-2'}}</span>
                                    <input autocomplete="off" type="number" class="number" *ngIf="!isPaid"
                                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                                        id="{{elementIds.txt_to_be_paid + '_'+(idxJ+1)}}" [(ngModel)]="itemSub.s_value"
                                        (input)="onCalculateNonEditAmount()" style="width: calc(100% - 15px);"
                                        placeholder="{{localService.languageContent.billing.paid_amount}}"
                                        title="{{localService.languageContent.billing.paid_amount}}"
                                        [ngClass]="itemSub.s_value ? 'en' : ''" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="banner" style="margin-top: 5px;" *ngIf="!isPaid">
            <div class="row" *ngIf="isShowPayAndSendToPhone">
                <div class="col-12">
                    <button type="button" style="width: 100%;margin-bottom: 10px;" class="btn btn-primary"
                        [id]="elementIds.btn_pay_send_phone" [disabled]="!selectedPaymentMode"
                        (click)="onAction(6)">{{localService.languageContent.billing.pay_send_phone}}</button>
                </div>
            </div>
            <div class="row" *ngIf="isShowPayAndPrint">
                <div class="col-12">
                    <button type="button" style="width: 100%;margin-bottom: 10px;" class="btn btn-primary"
                        [id]="elementIds.btn_pay_print" [disabled]="!selectedPaymentMode"
                        (click)="onAction(5)">{{localService.languageContent.billing.pay_print}}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <button type="button" style="width: 100%;" class="btn btn-primary" id="{{elementIds.btn_save}}"
                        [disabled]="!selectedPaymentMode || isRemainingPayment"
                        (click)="onAction(3)">{{localService.languageContent.common.save}}</button>
                </div>
                <div class="col-6">
                    <button type="button" style="width: 100%;" class="btn btn-primary" id="{{elementIds.btn_pay}}"
                        [disabled]="!selectedPaymentMode"
                        (click)="onAction(4)">{{localService.languageContent.billing.paid}}</button>
                </div>
            </div>
        </div>
        <div class="banner" style="margin-top: 5px;" *ngIf="paymentDetails.latePayments.length > 0">
            <div>
                <app-label [Text]="localService.languageContent.billing.late_payments" />
                <label class="en" style="float: right;margin-right: 16px;" *ngIf="totalLatePaidAmount > 0">
                    <span class="en" [innerHTML]="currencyIcon"></span>
                    {{totalLatePaidAmount.toFixed(2)}}
                </label>
            </div>
            <div class="box">
                <div class="row styled_row" *ngFor=" let latePayment of paymentDetails.latePayments; index as idxJ">
                    <div class="col-8">
                        <span class="en">{{latePayment.paidOn | date : 'dd-MMM-yyyy hh:mm a'}}</span>
                    </div>
                    <div class="col-4" style="text-align: right;">
                        <span class="en" [innerHTML]="currencyIcon"></span>
                        <span class="en">{{latePayment.paidAmount.toFixed(2)}}</span>
                    </div>
                </div>
            </div>
        </div>
    </ngb-toast>
</div>
}